<div class="c-calculator" *ngIf="!isLoading">
  <div class="c-calculator__actions">
    <div class="title" i18n="@@common.formula">Formula</div>
  </div>

  <div class="c-calculator__formula -view-only">
    <div class="content">
      <span *ngFor="let input of inputs; index as i">
        <ng-container [ngSwitch]="input.type">
          <ng-container *ngSwitchDefault>
            {{ input.value }}
          </ng-container>
          <ng-container *ngSwitchCase="Types.OPERATOR">
            {{ operators[input.value] }}
          </ng-container>
          <ng-container *ngSwitchCase="Types.METRIC">
            <span class="metric mr-0">{{ input.value }}</span>
          </ng-container>
        </ng-container>
      </span>
    </div>
  </div>
</div>
